import { Controller } from "@hotwired/stimulus"

// Prevents the open attribute from being morphed on details elements
// This preserves the user's interaction state during Turbo morphing
export default class extends Controller {
  preventToggle(event) {
    const { attributeName } = event.detail
    if (attributeName === "open") {
      event.preventDefault()
    }
  }
}